module.exports = __webpack_public_path__ + "static/img/icon_game_2.ee39f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_2.png
// module id = hG9j
// module chunks = 0